import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { ArticlePageWrapper } from "../Articles/PreviewArticle";
import { BreadCrumbsLoader } from "./Breadcrumbs";

const ArticleBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: Inter;
`;

export const ArticleLoader = ({ ...props }) => {
  return (
    <ArticlePageWrapper {...props}>
      <BreadCrumbsLoader />
      <ArticleBody>
        <ContentLoader
          viewBox="0 0 1000 60"
          height="60"
          width="100%"
          speed={2}
          preserveAspectRatio="none"
          style={{ marginBottom: "32px" }}
        >
          <rect x="0" y="0" rx="4" ry="4" width="800" height="40" />
        </ContentLoader>
        <ContentLoader
          viewBox="0 0 1000 600"
          height="600"
          width="100%"
          speed={2}
          preserveAspectRatio="none"
        >
          <rect x="0" y="0" rx="3" ry="3" width="1000" height="20" />
          <rect x="0" y="40" rx="3" ry="3" width="1000" height="20" />
          <rect x="0" y="80" rx="3" ry="3" width="950" height="20" />
          <rect x="0" y="120" rx="3" ry="3" width="1000" height="20" />
          <rect x="0" y="160" rx="3" ry="3" width="900" height="20" />
          <rect x="0" y="200" rx="3" ry="3" width="1000" height="20" />
          <rect x="0" y="240" rx="3" ry="3" width="850" height="20" />
        </ContentLoader>
      </ArticleBody>
    </ArticlePageWrapper>
  );
};

